<nb-card>
  <nb-card-header>
    <div class="summary">
      <div class="item">
        <div class="avatar">
          <button
            nbButton
            ghost
            shape="round"
            status="primary"
            size="small"
            class="action-button"
            (click)="loadContent()"
          >
            <nb-icon icon="more-horizontal-outline"></nb-icon>
          </button>
        </div>

        <div>
          <a (click)="loadContent()" class="link">
            <h6 class="text-body link">{{ product.title }}</h6>
          </a>
        </div>
      </div>
    </div>

    <div class="button-action">
      <a (click)="loadContent()" class="link">
        <h5 class="text-primary">{{ product.price | number }}</h5>
      </a>
    </div>
  </nb-card-header>

  <nb-card-body *ngIf="isMore">
    <div class="content">
      <ul class="detail">
        <li *ngIf="product.barcode">
          <label class="label">
            {{ "product.barcode" | translate }}:
            <span class="text-body"> {{ product.barcode }}</span>
          </label>
        </li>
        <li *ngIf="product.code">
          <label class="label">
            {{ "product.code" | translate }}:
            <span class="text-body"> {{ product.code }}</span>
          </label>
        </li>
        <li *ngIf="product.unitName">
          <label class="label">
            {{ "product.unit" | translate }}:
            <span class="text-body"> {{ product.unitName }}</span>
          </label>
        </li>
        <li *ngIf="product.wsPrice > 0">
          <label class="label">
            {{ "product.wsPrice" | translate }}:
            <span class="text-body"> {{ product.wsPrice | number }}</span>
          </label>
        </li>
        <li *ngIf="product.costPrice > 0 && user.moderator">
          <label class="label">
            {{ "product.costPrice" | translate }}:
            <span class="text-body"> {{ product.costPrice | number }}</span>
          </label>
        </li>
        <li *ngIf="product.groupName">
          <label class="label">
            {{ "common.groups" | translate }}:
            <span class="text-body"> {{ product.groupName }}</span>
          </label>
        </li>
        <li *ngIf="product.categoryName">
          <label class="label">
            {{ "common.categories" | translate }}:
            <span class="text-body"> {{ product.categoryName }}</span>
          </label>
        </li>
        <li *ngIf="product.producerName">
          <label class="label">
            {{ "common.producers" | translate }}:
            <span class="text-body"> {{ product.producerName }}</span>
          </label>
        </li>
        <li *ngIf="product.originName">
          <label class="label">
            {{ "common.origins" | translate }}:
            <span class="text-body"> {{ product.originName }}</span>
          </label>
        </li>
        <li *ngIf="product.sizeName">
          <label class="label">
            {{ "common.sizes" | translate }}:
            <span class="text-body"> {{ product.sizeName }}</span>
          </label>
        </li>
        <li *ngIf="product.colorName">
          <label class="label">
            {{ "common.colors" | translate }}:
            <span class="text-body"> {{ product.colorName }}</span>
          </label>
        </li>
        <li *ngIf="product.description?.length > 0">
          <label class="label"> {{ "common.note" | translate }}: </label><br />
          <span class="description"> {{ product.description }}</span>
        </li>
        <li *ngIf="product.note1?.length > 0">
          <label class="label"> EXP note: </label>
          <span class="description">{{ product.note1 }}</span>
        </li>
        <li *ngIf="product.note2?.length > 0">
          <label class="label"> Detail: </label>
          <span class="description">{{ product.note2 }}</span>
        </li>

        <!-- <li *ngIf="product.expDate">
          <label class="label">
            Hạn sử dụng
            <span class="text-body">
              {{ product.expDate | date: "dd/MM/yyyy" }}</span
            >
          </label>
        </li> -->
      </ul>

      <ngx-view-image
        *ngIf="product.coverUrl"
        [imageURL]="product.coverUrl"
      ></ngx-view-image>
    </div>

    <ngx-view-gallery
      *ngIf="product.imagesUrl?.length > 0"
      [imagesUrl]="product.imagesUrl"
    >
    </ngx-view-gallery>

    <div class="content">
      <a *ngIf="isMore" (click)="loadContent()" class="link text-link">
        <nb-icon icon="chevron-up-outline"></nb-icon>
      </a>

      <div class="button-action">
        <button
          nbButton
          ghost
          status="danger"
          size="small"
          [disabled]="submitted"
          [class.btn-pulse]="submitted"
          (click)="delete(product)"
        >
          <nb-icon icon="trash-2-outline"></nb-icon>
        </button>

        <button
          nbButton
          ghost
          status="info"
          size="small"
          [disabled]="submitted"
          [class.btn-pulse]="submitted"
          (click)="edit(product)"
        >
          <nb-icon icon="edit-2-outline"></nb-icon>
        </button>

        <button
          nbButton
          ghost
          status="success"
          size="small"
          [disabled]="submitted"
          [class.btn-pulse]="submitted"
          (click)="printProduct(product)"
        >
          <nb-icon icon="printer-outline"></nb-icon>
        </button>
      </div>
    </div>
  </nb-card-body>
</nb-card>
